export const data = {
	data() {
		return {
			headerList: [ // 表头
				{
					prop: 'product_title',
					label: '退款课程',
					width: 260
				},
				{
					prop: 'refund_amount',
					label: '退款金额/件数',
					align: 'center',
					width: 150
				},
				{
					prop: 'type',
					label: '退款类型/原因',
					width: 220,
					showOverflowTooltip: true
				},
				{
					prop: 'status',
					label: '退款状态',
					width: 130
				},
				{
					prop: 'logistics_status',
					label: '物流状态'
				},
				// {
				// 	prop: 'talent_name',
				// 	label: '推广人抖音昵称',
				// 	width: 150
				// },
				// {
				// 	prop: 'buyer_nickname',
				// 	label: '购买人',
				// 	width: 140
				// },
			],
			stateList: [ // 退款状态列表
				{
					value: '',
					label: '全部'
				},
				{
					value: 0,
					label: '用户取消申请'
				},
				{
					value: 1,
					label: '商家受理中', 
					showRest: true, // 展示剩余时间
					showAgreeBtn: true, // 展示同意按钮
					showRejectBtn: true // 展示拒绝按钮
				},
				{
					value: 2,
					label: '商家拒绝退款'
				},
				{
					value: 3,
					label: '商家拒绝退货退款'
				},
				{
					value: 4,
					label: '待买家退货'
				},
				{
					value: 5,
					label: '退货退款关闭'
				},
				{
					value: 6,
					label: '待商家收货'
				},
				{
					value: 7,
					label: '商家逾期未退款'
				},
				{
					value: 8,
					label: '退款完成'
				},
				{
					value: 9,
					label: '退货退款完成'
				},
				{
					value: 10,
					label: '平台退款中'
				},
				{
					value: 11,
					label: '平台退款失败'
				},
				{
					value: 12,
					label: '待用户确认'
				},
				{
					value: 13,
					label: '商家打款失败,客服关闭售后'
				},
				{
					value: 14,
					label: '售后关闭'
				},
				{
					value: 15,
					label: '待用户处理商家协商'
				},
				{
					value: 16,
					label: '待用户处理商家代发起的售后申请'
				},
			],
			reasonList: [ // 退款原因
				{
					"reason": "",
					"reason_text": "全部"
				},{
					"reason": "10000000",
					"reason_text": "不想要了"
				}, {
					"reason": "10000001",
					"reason_text": "缺货"
				}, {
					"reason": "10000002",
					"reason_text": "拍错/多拍"
				}, {
					"reason": "10000003",
					"reason_text": "没用/少用优惠"
				}, {
					"reason": "10000004",
					"reason_text": "地址/电话等信息填写错误"
				}, {
					"reason": "10000005",
					"reason_text": "少件/漏发"
				}, {
					"reason": "10000006",
					"reason_text": "卖家发错货"
				}, {
					"reason": "10000007",
					"reason_text": "未收到商品"
				}, {
					"reason": "10000008",
					"reason_text": "其他"
				}, {
					"reason": "10000009",
					"reason_text": "无快递信息"
				}, {
					"reason": "10000010",
					"reason_text": "商家未按约定时间发货"
				}, {
					"reason": "10000011",
					"reason_text": "与商品描述不符"
				}, {
					"reason": "10000012",
					"reason_text": "拍错/不想去了"
				}, {
					"reason": "10000013",
					"reason_text": "商家无法提供服务"
				}, {
					"reason": "10000014",
					"reason_text": "双方协商一致退款"
				}, {
					"reason": "10000015",
					"reason_text": "快递长时间未送达"
				}, {
					"reason": "10000016",
					"reason_text": "包裹为空"
				}, {
					"reason": "10000017",
					"reason_text": "物流无跟踪记录"
				}, {
					"reason": "10000018",
					"reason_text": "已拒签包裹"
				}, {
					"reason": "10000019",
					"reason_text": "7天无理由"
				}, {
					"reason": "10000020",
					"reason_text": "无法使用"
				}, {
					"reason": "10000021",
					"reason_text": "质量问题"
				}, {
					"reason": "10000022",
					"reason_text": "联系不到商家"
				}, {
					"reason": "10000023",
					"reason_text": "课程/服务与描述不符"
				}, {
					"reason": "10000024",
					"reason_text": "未收到课程/服务"
				}, {
					"reason": "10000025",
					"reason_text": "已过/临近保质期"
				}, {
					"reason": "10000026",
					"reason_text": "商品变质不新鲜"
				}, {
					"reason": "10000027",
					"reason_text": "过敏"
				}, {
					"reason": "10000028",
					"reason_text": "肤质不匹配"
				}, {
					"reason": "10000029",
					"reason_text": "宠物食用不适"
				}, {
					"reason": "10000030",
					"reason_text": "缩水/褪色"
				}, {
					"reason": "10000031",
					"reason_text": "开线/走丝"
				}, {
					"reason": "10000032",
					"reason_text": "枯萎/死亡"
				}, {
					"reason": "10000033",
					"reason_text": "假冒产品"
				}, {
					"reason": "10000034",
					"reason_text": "三无产品"
				}, {
					"reason": "10000035",
					"reason_text": "无效"
				}, {
					"reason": "10000036",
					"reason_text": "因订单存在交易风险，平台为保护消费者权益，支付金额已原路退回并对该商家进行处罚，带来的不便还请谅解"
				}, {
					"reason": "10000037",
					"reason_text": "自动退款失败发起售后线下退款流程"
				}, {
					"reason": "10000038",
					"reason_text": "超卖砍单后退款失败发起售后线下退款流程"
				}, {
					"reason": "10000039",
					"reason_text": "大小/尺寸与商品描述不符"
				}, {
					"reason": "10000040",
					"reason_text": "包装/商品破损/污渍/裂痕/变形"
				}, {
					"reason": "10000041",
					"reason_text": "功能/效果与商品描述不符"
				}, {
					"reason": "10000042",
					"reason_text": "材质/面料与商品描述不符"
				}, {
					"reason": "10000043",
					"reason_text": "颜色/图案/款式与商品描述不符"
				}, {
					"reason": "10000044",
					"reason_text": "误认为是外卖"
				}, {
					"reason": "10000045",
					"reason_text": "没看清使用规则，要用时才发现有限制"
				}, {
					"reason": "10000046",
					"reason_text": "商家停业/装修/转让"
				}, {
					"reason": "10000047",
					"reason_text": "需要加价/购买其他产品才能用"
				}, {
					"reason": "10000048",
					"reason_text": "商家要求改用其它方式/平台付款"
				}, {
					"reason": "10000049",
					"reason_text": "不能送外卖"
				}, {
					"reason": "10000050",
					"reason_text": "朋友/网上评价不好"
				}, {
					"reason": "10000051",
					"reason_text": "排队太久"
				}, {
					"reason": "10000052",
					"reason_text": "可用门店距离太远"
				}, {
					"reason": "10000053",
					"reason_text": "担心安全问题（疫情、天气等）"
				}, {
					"reason": "10000054",
					"reason_text": "预约不到合适的时间"
				}, {
					"reason": "10000055",
					"reason_text": "服务态度不好"
				}, {
					"reason": "10000056",
					"reason_text": "少件/漏发/发错货/空包裹"
				}, {
					"reason": "10000057",
					"reason_text": "实物与商品描述不符"
				}, {
					"reason": "10000058",
					"reason_text": "三无/假冒产品"
				}, {
					"reason": "10000059",
					"reason_text": "拍错/少用优惠"
				}, {
					"reason": "10000060",
					"reason_text": "拍错/多拍/没用或少用优惠"
				}, {
					"reason": "10000061",
					"reason_text": "未收到商品/快递长时间未送达"
				}, {
					"reason": "10000062",
					"reason_text": "与描述不符"
				}, {
					"reason": "10000064",
					"reason_text": "缩水/开线/破损/变形等质量问题"
				}, {
					"reason": "10000065",
					"reason_text": "商品破损/污渍/裂痕/变形等质量问题"
				}, {
					"reason": "10000066",
					"reason_text": "缩水/褪色/质量问题"
				}
			]
		}
	}
}